import { defineComponent, reactive, ref, onMounted, watch, toRefs, nextTick, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { HttpService } from "@/core";
import { Empty, message } from "ant-design-vue";
import { useStore } from "@/store";
import { windowChangeEmitter } from "@/utils/emitter";
import { WorkProgressService } from "./work-progress.service";
import moment from "moment";
import mixins from "@/core/mixins/table-height.mixins";
import { VxeTablePropTypes } from "vxe-table";
import ArrayToTree from "array-to-tree";
import { PlanTableService } from "@/views/work-manage/project-plan/form/plan-table/plan-table.service";
import { onMountedOrActivated } from "@/core/hooks/onMountedOrActivated";
import _ from "lodash";
import { FloatObj } from "@/utils/floatObj";
export default defineComponent({
  isGlobal: true,
  name: "WorkProgress",
  components: {},
  props: {
    currentRow: {
      type: Object,
      default: () => {},
    },
    projectId:{
      type: String,
      default: "",
    }
  },
  emits: ["close"],
  setup(props, { emit }) {
    const defaultDate = moment();
    const diffHeight = 60;
    const { setTableHeight, tableHeight } = mixins();
    const displayQuanping = ref(false);
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const state = reactive({
      source: "",
      holidays: true,
      weekend: true,
      singleRest: true,
      offDay: "saturday",
      tableRef: ref(),
      holidaysArr: computed(() => store?.state?.holidays?.holidays),
      workdaysArr: computed(() => store?.state?.holidays?.workdays),
      comLoading: true,
    });
    let { data: planData, run, loading } = WorkProgressService.usePanelProgressListApi();
  
    const { run: runHolidays } = PlanTableService.useHolidaysApi();
    const tableData = ref<any>([]);
    const getTotalMaxMinDate = (arr) => {
      let initDate = undefined as any;
      let min = initDate;
      let max = initDate;
      arr.forEach((item) => {
        let tmp = moment(item.planStartDate);
        let tmp2 = moment(item.planEndDate);
        if(!item.planEndDate){
          tmp2=tmp
        }
        if (!min || tmp.diff(min) < 0) {
          min = tmp;
        }

        if (!max || tmp2.diff(max) > 0) {
          max = tmp2;
        }
        
      });

      return { max, min };
    };
    const headerTh = ref<Object>([]);
    const getHeaderTh = (list) => {
      let { max, min } = getTotalMaxMinDate(list);
      let { actualMax, actualMin } = getActualMaxMinDate(list);
      // console.log(max, min, max.diff(min, "months", true));
      if (min > actualMin) {
        min = actualMin;
      }
      if (max < actualMax) {
        max = actualMax;
      }
      
      // console.log("🚀 ~ file: work-progress.controller.ts:78 ~ getHeaderTh ~ max:", max,min)
      let monthObj = {};
      list.forEach((item) => {
        let key = item.planStartDate.substring(0, 7);
        if (!monthObj[key]) {
          monthObj[key] = true;
        }
        let key2 = item.planEndDate.substring(0, 7);
        if (!monthObj[key2]) {
          monthObj[key2] = true;
        }

        let key3 = item.actualStartDate?.substring(0, 7);
        if (key3 && !monthObj[key3]) {
          monthObj[key3] = true;
        }
        let key4 = item.actualEndDate?.substring(0, 7);
        if (key4 && !monthObj[key4]) {
          monthObj[key4] = true;
        }
      });
      let arr = [] as Array<Object>;
      let months = Object.keys(monthObj);
      let tmpMo=moment(min.format("YYYY-MM-01 00:00:00"));
      months=[]
      while(tmpMo<=max){
        months.push(tmpMo.format("YYYY-MM"))
        tmpMo.add(1,"M")
      }
      months = months.sort();
      // console.log("months.................", months);
      months.forEach((m) => {
        let tmp = {
          title: m,
          children: [] as Array<Object>,
        };
        //先判断是否是最小月份
        if (m == min.format("YYYY-MM")) {
          //取出当月的最大天数
          let currentMonthMaxDays = min.daysInMonth();
          let { date: s } = min.toObject();
          for (let i = s; i <= currentMonthMaxDays; i++) {
            tmp.children.push({ day: i, str: i < 10 ? "0" + i : i });
          }
        } else if (m == max.format("YYYY-MM")) {
          //再判断是否是最大月
          let { date: s } = max.toObject();
          for (let i = 1; i <= s; i++) {
            tmp.children.push({ day: i, str: i < 10 ? "0" + i : i });
          }
        } else {
          //是中间月份
          let currentMonthMaxDays = moment(m).daysInMonth();
          for (let i = 1; i <= currentMonthMaxDays; i++) {
            tmp.children.push({ day: i, str: i < 10 ? "0" + i : i });
          }
        }
        arr.push(tmp);
      });
      //过滤掉没有施工进度的天数
      // filterNoWork(arr, list);
      headerTh.value = arr;
      // console.log("arr...........................", list);
      // console.log("headerTh", headerTh);
    };
    //过滤掉没有施工进度的天数
    const filterNoWork = (arr, list) => {
      let deleteArrIndex = [] as String[];
      arr.forEach(({ title, children }) => {
        let deleteIndex = [] as Number[];
        children.forEach((m) => {
          let i = "";
          if (m.day < 10) {
            i = "0" + m.day;
          } else {
            i = m.day;
          }
          let str = title + "-" + i;
          let flg = list.some((ii) => {
            return ii.customeTime.some((o) => o.planStartDate <= str && str <= o.planEndDate);
          });
          let flg2 = list.some((ii) => {
            return ii.customeTime.some((o) => o.actualStartDate <= str && str <= o.actualEndDate);
          });
          if (!flg && !flg2) {
            // console.log(str);
            deleteIndex.push(m.day);
          }
        });
        deleteIndex.forEach((m) => {
          // console.log(m);
          children.splice(
            children.findIndex((p) => p.day == m),
            1
          );
        });
        if (children.length == 0) {
          // console.log(title);
          deleteArrIndex.push(title);
        }
      });
      deleteArrIndex.forEach((ii) =>
        arr.splice(
          arr.findIndex((o) => ii == o.title),
          1
        )
      );
    };
    const currentProjectId = computed(() => {
      // getProgressDataList(route.query?.projectId || props.currentRow?.id);
      // // console.log(
      //   "🚀 ~ file: work-progress.controller.ts:183 ~ currentProjectId ~ props.currentRow:",
      //   props.currentRow
      // );
      return route.query?.projectId || props.currentRow?.id;
    });
    const getMaxMinDate = (arr) => {
      let initDate = undefined as any;
      if (arr.every((i) => !i.planStartDate && !i.planEndDate)) {
        initDate = defaultDate;
      } else {
        arr.forEach((i) => {
          if (i.planStartDate && i.planEndDate) {
            initDate = moment(i.planStartDate);
          }
        });
      }
      let min = initDate;
      let max = initDate;
      arr.forEach((o) => {
        let tmp = moment(o.planStartDate);
        let tmp2 = moment(o.planEndDate);
        if (tmp.diff(min) < 0) {
          min = tmp;
        }
        if (tmp2.diff(max) > 0) {
          max = tmp2;
        }
      });
      return { max, min };
    };
    const getActualMaxMinDate = (arr) => {
      let initDate = undefined as any;
      let min = initDate;
      let max = initDate;
      arr.forEach((o) => {
        let tmp = moment(o.actualStartDate);
        let tmp2 = moment(o.actualEndDate);
        if(!o.actualEndDate){
          tmp2=tmp
        }
        if (!min || tmp.diff(min) < 0) {
          min = tmp;
        }
        if (!max || tmp2.diff(max) > 0) {
          max = tmp2;
        }
      });
      return { actualMax: max, actualMin: min };
    };
    const getProgressDataList = async (id?) => {
      let res = await run(id|| currentProjectId.value);
      let list = (res.data as any)?.detail || [];      
      // console.log("list==========================", list);
      if (list?.length > 0) {
        getHeaderTh(list);
        tableData.value = ArrayToTree(list, {
          parentProperty: "parentId",
          customID: "uuid",
        });
        nextTick(() => {
          const $table = state.tableRef.value;
          state.comLoading=false
          if ($table) {
            $table.setAllTreeExpand(true);
            
          }
        });
      }else{
        state.comLoading=false
      }
    };    
    const getProgressDataListByProjectId = async (id?) => {
      let res = await run(id || currentProjectId.value,{},true);
      // console.log("🚀 ~ file: work-progress.controller.ts:263 ~ getProgressDataListByProjectId ~ res:", res)
      let list = (res.data as any)?.detail || [];      
      if (list?.length > 0) {
        getHeaderTh(list);
        tableData.value = ArrayToTree(list, {
          parentProperty: "parentId",
          customID: "uuid",
        });
        nextTick(() => {
          const $table = state.tableRef.value;
          state.comLoading=false
          if ($table) {
            $table.setAllTreeExpand(true);
            
          }
        });
      }else{
        state.comLoading=false

      }
    };
    watch(
      () => props.currentRow,
      async () => {
        nextTick(async () => {
          setTableHeight(diffHeight);
          if(props.currentRow&&props.currentRow.id){
            await getProgressDataList(props.currentRow?.id);
          }
        });
      },
      {
        immediate: true,
        deep: true,
      }
    );
    watch(
      () => props.projectId,
      async () => {
        nextTick(async () => {
          setTableHeight(diffHeight);
          if(props.projectId){
            await getProgressDataListByProjectId(props.projectId);
          }
        });
      },
      {
        immediate: true,
        deep: true,
      }
    );
    onMountedOrActivated(async () => {
      setTableHeight(diffHeight);
      let res = await runHolidays();
      // console.log("🚀 ~ file: work-progress.controller.ts:325 ~ onMountedOrActivated ~ res:", res);
    });
    const contractId = ref(route.query.contractId);
    const projectNo = ref(route.query.projectNo);
    const contractNo = ref(route.query.contractNo);
    const projectName = ref(route.query.projectName || props.currentRow?.projectName);
    const search = async () => {
      tableData.value = [];
      if (!0) {
        return;
      }
      //   contractId.value = info.contractId;
      //   projectNo.value = info.bizNo;
      //   contractNo.value = info.projectContractCode;
      //   projectName.value = info.name;
      //   projectId.value = info.id;
      //   await getProgressDataList();
      //   // console.log(queryParam);
    };
    const openFn = () => {
      displayQuanping.value = true;
      setTimeout(() => {
        setTableHeight(0);
      }, 50);
    };
    const closeFn = () => {
      displayQuanping.value = false;
      setTimeout(() => {
        setTableHeight(diffHeight);
      }, 50);
    };
    const headerCellClassName: VxeTablePropTypes.HeaderCellClassName = ({ column }) => {
      if ("施工时间/天" == column.property) {
        return "col-blue";
      }
      return null;
    };
    const isToday = (date) => {
      return moment(moment().format("YYYY-MM-DD")).isSame(date);
    };
    const isRest = (date) => {
      let dates = moment(date).format("YYYY-MM-DD");
      if (planData.value?.excludeHolidays==1&&state.holidaysArr.includes(dates)) {
        //节假日
        return false;
      }
      if (state.workdaysArr.includes(dates)) {
        //调休日
        return true;
      }
      if (planData.value?.restType == 1 && [6, 0].includes(new Date(date).getDay())) {
        //双休
        return false;
      }
      if (
        planData.value?.restType == 2 &&
        ((planData.value?.singleRestDay == 6 && [6].includes(new Date(date).getDay())) ||
          (planData.value?.singleRestDay == 7 && [0].includes(new Date(date).getDay())))
      ) {
        return false;
      }
      return true;
    };
    const seqMethod = ({ seq, row, rowIndex }) => {     
      return FloatObj.subtract(Number(seq), 1, 2);
    };
    const goto = () => {
      emit("close");
      router.push("/work-manage/progress/list?projectName=" + planData.value?.projectName);
    };
    return {
      projectName,
      contractNo,
      projectNo,
      contractId,
      ...toRefs(state),
      tableHeight,
      tableData,
      loading,
      headerTh,
      displayQuanping,
      currentProjectId,
      search,
      openFn,
      closeFn,
      headerCellClassName,
      simpleImage: Empty.PRESENTED_IMAGE_SIMPLE,
      planData,
      isToday,
      isRest,
      seqMethod,
      goto,
    };
  },
});
